enum ModuleEnum {
  AccountingIntegrations = 'Accounting Integrations',
  AccountManagement = 'Account Management',
  AppointmentBilling = 'Standard Appointment Billing',
  AutomationsAlerts = 'Automations Alerts',
  AutomationsHasHad = 'Automations Has Had',
  Classes = 'Classes',
  ClinicalServices = 'Clinical Services',
  CommunicationBasic = 'Communication (Basic)',
  CommunicationAdvanced = 'Communication (Advanced)',
  CommunicationEnhanced = 'Communication (Enhanced)',
  ConnectHideFromExplorer = 'Connect Hide From Explorer',
  ContactsBasic = 'Contacts (Basic)',
  ContactsAdvanced = 'Contacts (Advanced)',
  CreditBasedPackages = 'Credit Based Packages',
  CRMBasic = 'CRM (Basic)',
  CRMAdvanced = 'CRM (Advanced)',
  Dashboard = 'Dashboard',
  DiaryBasic = 'Diary (Basic)',
  DiaryAdvanced = 'Diary (Advanced)',
  DiaryEnhanced = 'Diary (Enhanced)',
  TreatmentAuthorisation = 'Treatment Authorisation',
  DiarySkills = 'Diary Skills',
  DigitalPrescriptions = 'Digital Prescriptions',
  ExerciseIntegrations = 'Exercise Integrations',
  FinanceBasic = 'Finance (Basic)',
  FinanceAdvanced = 'Finance (Advanced)',
  Forms = 'Forms',
  GarageServices = 'Garage Services',
  Healthcode = 'Healthcode Integration',
  MultiLocation = 'Multi Location',
  MyAccount = 'My Account Section',
  MyAccountInvoices = 'My Account Invoice',
  MyAccountSubscription = 'My Account Subscription Section',
  MyAccountContacts = 'My Account Contacts',
  OnlineBookingsBasic = 'Online Bookings (Basic)',
  OnlineBookingsAdvanced = 'Online Bookings (Advanced)',
  Optical = 'Optical',
  Packages = 'Packages and Subscriptions',
  PayPerClick = 'Pay Per Click',
  PostcodeLookup = 'Address/Postcode Lookup',
  ProntoReferrals = 'Pronto Referrals',
  QuickStartWizard = 'QuickStartWizard',
  ReceptionServices = 'Reception Services',
  ReportingBasic = 'Reporting (Basic)',
  ReportingAdvanced = 'Reporting (Advanced)',
  SecurityBasic = 'Security (Basic)',
  SecurityAdvanced = 'Security (Advanced)',
  SecurityEnhanced = 'Security (Enhanced)',
  SettingsBasic = 'Settings (Basic)',
  SettingsAdvanced = 'Settings (Advanced)',
  SMSBundles = 'SMS Bundles',
  SocialSignOn = 'Social Sign On',
  StockBasic = 'Stock (Basic)',
  StockAdvanced = 'Stock (Advanced)',
  SystemCredits = 'System Credits',
  TechnicalSupport = 'Technical Support (Basic)',
  TechnicalSupportAdvanced = 'Technical Support (Advanced)',
  Telehealth = 'Telehealth',
  TreatmentBasic = 'Treatment (Basic)',
  TreatmentAdvanced = 'Treatment (Advanced)',
  TreatmentEnhanced = 'Treatment (Enhanced)',
  Worksheets = 'Worksheets',
  TaxExemption = 'Tax Exemption'
}
export default ModuleEnum;
